// extracted by mini-css-extract-plugin
export default {"Companies":"styles_Companies__pmq61","companies":"styles_companies__ez5Fi","scroll":"styles_scroll__n5iTo","noFavorites":"styles_noFavorites__Zw72R"};